import { format, parseISO } from 'date-fns'
import { nl } from 'date-fns/locale'

export function euro(value: number) {
  return `€ ${value.toLocaleString('nl-NL', { maximumFractionDigits: 2 })}`
}

export function longDate(iso: string) {
  return format(parseISO(iso), 'EEEE d MMMM', { locale: nl })
}

export function shortDate(iso: string) {
  return format(parseISO(iso), 'd MMM yyyy', { locale: nl })
}

export function monthLabel(date: Date) {
  return format(date, 'MMMM yyyy', { locale: nl })
}

export function duration(minutes: number) {
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  if (hours === 0) return `${rest} min`
  if (rest === 0) return `${hours} uur`
  return `${hours} uur ${rest} min`
}

export function timeRange(time: string, minutes: number) {
  const [h, m] = time.split(':').map(Number)
  const end = new Date(2000, 0, 1, h, m + minutes)
  return `${time} — ${format(end, 'HH:mm')}`
}

export function reference() {
  const stamp = Date.now().toString(36).toUpperCase().slice(-4)
  const rand = Math.random().toString(36).toUpperCase().slice(2, 4)
  return `DCC-${stamp}${rand}`
}

export function icsFile(params: {
  reference: string
  title: string
  date: string
  time: string
  minutes: number
  location: string
  description: string
}) {
  const [h, m] = params.time.split(':').map(Number)
  const start = new Date(`${params.date}T00:00:00`)
  start.setHours(h, m, 0, 0)
  const end = new Date(start.getTime() + params.minutes * 60000)
  const stamp = (d: Date) => format(d, "yyyyMMdd'T'HHmmss")

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Daily Car Care//Booking//NL',
    'BEGIN:VEVENT',
    `UID:${params.reference}@dailycc.nl`,
    `DTSTAMP:${stamp(new Date())}`,
    `DTSTART:${stamp(start)}`,
    `DTEND:${stamp(end)}`,
    `SUMMARY:${params.title}`,
    `LOCATION:${params.location}`,
    `DESCRIPTION:${params.description}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ]

  return `data:text/calendar;charset=utf-8,${encodeURIComponent(lines.join('\r\n'))}`
}
